import store from './store';

export default class NotificationObject {
  constructor(type, content) {
    this.type = type;
    if (typeof content === 'string') {
      this.content = [content];
    } else {
      this.content = content;
    }
    this.id = `notification_${type}_${new Date().getTime()}_${Math.random()}`;
  }
}

const showErrorNotification = function (message) {
  return showErrorNotification(message, 'error');
}

const showInfoNotification = function (message) {
  return showErrorNotification(message, 'info');
}

const showWarningNotification = function (message) {
  return showErrorNotification(message, 'warning');
}

const showNotification = function (message, type = 'error') {
  store.commit(
    'addNotification',
    new NotificationObject(type, message)
  );
}

export {
  showNotification,
  showErrorNotification,
  showInfoNotification,
  showWarningNotification
}
